import { MEDIA_MIME_TYPES_TO_EXTENSION } from "@rapid/constants/media";

export async function fileFromUrl({ url, name }: { url: string; name: string }) {
    const response = await fetch(url);
    const contentType = response.headers.get("Content-Type");
    if (!contentType) throw new Error("Content type not found");
    const ext = MEDIA_MIME_TYPES_TO_EXTENSION[contentType]?.ext;
    if (!ext) throw new Error(`Unsupported content type: ${contentType}`);
    const data = await response.blob();
    const metadata = { type: contentType };
    return new File([data], name + ext, metadata);
}
